export interface CategoryMeta {
  type: string;
  name: string;
  shortName: string;
  intro: string;
  description: string;
  icon: string;
  cover: string;
}

export const categories: CategoryMeta[] = [
  {
    type: "laws",
    name: "法律法规",
    shortName: "法规",
    intro: "禁婚亲属范围、性侵犯罪中的亲属情节、未成年人保护等法律条文与司法解读。",
    description:
      "本分类系统梳理与近亲性关系相关的法律法规，包括婚姻家庭编中的禁婚亲属制度、刑法中相关罪名的构成要件与量刑情节，以及未成年人保护法律框架，帮助读者准确理解法律界限。",
    icon: "ri-scales-3-line",
    cover:
      "https://readdy.ai/api/search-image?query=Classical%20marble%20courthouse%20columns%20under%20a%20deep%20navy%20blue%20sky%2C%20symmetrical%20architecture%2C%20authoritative%20and%20serene%20mood%2C%20fine%20art%20photography%2C%20cool%20tone%2C%20clean%20composition%2C%20no%20people&width=800&height=600&seq=cat-laws-2026a&orientation=landscape",
  },
  {
    type: "ethics",
    name: "伦理道德",
    shortName: "伦理",
    intro: "伤害原则、知情同意、权力不对等与家庭信任等伦理视角的理性讨论。",
    description:
      "本分类从伦理学与社会规范出发，讨论近亲性关系争议背后的伤害原则、同意理论、权力不对等以及对家庭信任与社会功能的冲击，倡导理性、克制而不猎奇的公共讨论。",
    icon: "ri-lightbulb-flash-line",
    cover:
      "https://readdy.ai/api/search-image?query=Abstract%20minimalist%20balance%20concept%20with%20smooth%20stone%20shapes%20resting%20on%20a%20matte%20surface%2C%20muted%20navy%20and%20teal%20palette%2C%20soft%20gradient%20light%2C%20calm%20philosophical%20mood%2C%20no%20people&width=800&height=600&seq=cat-ethics-2026a&orientation=landscape",
  },
  {
    type: "cases",
    name: "案例分析",
    shortName: "案例",
    intro: "以虚构、去标识化案例，解析婚姻效力、刑事量刑与未成年人保护。",
    description:
      "本分类以虚构且去标识化的教学案例为核心，解析禁婚亲属婚姻效力、刑事诉讼中的证据与量刑、监护权撤销等实务问题，仅用于法律与伦理知识普及，不涉及任何真实个案隐私。",
    icon: "ri-folders-line",
    cover:
      "https://readdy.ai/api/search-image?query=Close-up%20of%20a%20wooden%20judge%20gavel%20resting%20beside%20neatly%20stacked%20legal%20documents%2C%20deep%20navy%20tones%20with%20a%20subtle%20red%20accent%2C%20professional%20still%20life%2C%20soft%20directional%20shadows%2C%20no%20people&width=800&height=600&seq=cat-cases-2026a&orientation=landscape",
  },
];

export const categoryMap: Record<string, CategoryMeta> = {
  laws: categories[0],
  ethics: categories[1],
  cases: categories[2],
};